import { ProsAndCons } from '@ria-client/tw-shared-ui';
import type { NodeProps } from '../types';

export type SMBProsAndConsTableProps = NodeProps<{
  pros?: string[];
  cons?: string[];
}>;

export function SMBProsAndConsTable({ props }: SMBProsAndConsTableProps) {
  return (
    <div className="p-4">
      <ProsAndCons consList={props.cons} prosList={props.pros} />
    </div>
  );
}
